module.exports = __webpack_public_path__ + "img/bb_g3_antenna-03.7624ce0d.svg";